import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_CustomColumnRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbCustomColumn} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Custom_Column
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";
import {IPolicyCollection} from "../PA.Core/PA.Core.IF.Policy";
import {IHaveSecurity} from "../PA.Core/PA.Core.IF.Aspects";
import {PolicyCollection} from "../PA.Core/Security/PolicyCollection";
import {PolicyBOis} from "../PA.Core/Security/PolicyBOis";
import {PolicyHasRole} from "../PA.Core/Security/PolicyHasRole";
import {CustomColumnPolicy} from "./CustomColumnPolicy";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

export class CustomColumnBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_CustomColumn: WB_CustomColumnRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Custom Column'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_CustomColumn = null;
        this.IHaveSecurity_init();
    }

    get WB_CustomColumn(): WB_CustomColumnRow {
        return this.drWB_CustomColumn;
    }

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating CustomColumn");
        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error)=>{

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                let sError = "Unable to determine dbContext for new Custom Column.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_Custom_Column)
                .then((newCustomColumnRow: WB_CustomColumnRow)=>{
                    newCustomColumnRow.setDefaults();
                    self.drWB_CustomColumn = newCustomColumnRow;
                    self.dbContext.add(esWB_Custom_Column, newCustomColumnRow);
                    self.Identity.setAll(self.WB_CustomColumn.cif.WB_CUSTOM_COLUMN_ID, self.WB_CustomColumn.cif.WB_CUSTOM_COLUMN_ID, self.WB_CustomColumn.cif. COLUMN_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_CustomColumn, 'WB_CUSTOM_COLUMN_ID','WB_CUSTOM_COLUMN_ID','COLUMN_NAME');

                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err);
                    error(err)
                })
        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error)=>{

            if (self.bIsLoaded) {
                let sError = "Custom Column already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            self.LoadOptions = options || {};

            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if(self.dbContext == null)
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                let sError = "Unable to determine dbContext for Custom Column.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            if('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any> self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = CustomColumnBO.createRecordResolver({dbContext: self.dbContext});
                recordResolverLoadPromise = CustomColumnBO.setupRecordResolver(recordResolver, [anId])
            }

            recordResolverLoadPromise
                .then(function () {
                    let newCustomColumnRow: any = recordResolver.get(esWB_Custom_Column, anId);

                    if(_.isEmpty(newCustomColumnRow))
                    {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_CustomColumn = newCustomColumnRow;
                    self.Identity.setAll(self.WB_CustomColumn.cif.WB_CUSTOM_COLUMN_ID, self.WB_CustomColumn.cif.WB_CUSTOM_COLUMN_ID, self.WB_CustomColumn.cif.COLUMN_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_CustomColumn, 'WB_CUSTOM_COLUMN_ID','WB_CUSTOM_COLUMN_ID','COLUMN_NAME');
                })
                .then((newCustomColumnRow:any) => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch((err:any)=>{
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    error(err);
                });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {

        if (this._bIsLoaded) {
            return ASync.resolve(this)
        }
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    Validate(options?: any): Promise<IBusinessObject> {

        let self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_CustomColumn.cif.CustomColumn_NAME + "(" + self.WB_CustomColumn.cif.WB_CUSTOM_COLUMN_ID + ")");
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == undefined) {
                let sError = "Unable to determine dbContext to Validate Custom Column.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        const self = this;
        const wbCustomColumn = <IwbCustomColumn>self.drWB_CustomColumn;
        this.SaveProgressProvider.start("Saving " + wbCustomColumn.CustomColumn_NAME + "(" + wbCustomColumn.WB_CUSTOM_COLUMN_ID + ")");

        return new Promise<IBusinessObject>((resolve, reject)=>{
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // We could search the tree if there is any record where store isn't set.

            if (self.dbContext == null) {
                self._bIsSaved = false;
                let sError = "Unable to determine dbContext to Save Custom Column.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }

            self.SaveOptions = options || {};

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>;
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext);
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext);
            }

            saveFunction(esWB_Custom_Column, self.drWB_CustomColumn, {})
                .then((ignored)=>{
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(()=> {
                            self._bIsSaved = true;

                        })
                    } else {
                        self._bIsSaved = true;

                    }
                }).then(() => {
                //  self._bIsCreatedMode = false ;
                return self.IHaveSecurity_AfterSaveComplete();
            }) .then(()=>{
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self);
                })
        })
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        const wbCustomColumn = <IwbCustomColumn>self.drWB_CustomColumn;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbCustomColumn.COLUMN_NAME + "(" + wbCustomColumn.WB_CUSTOM_COLUMN_ID + ")");

        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the Customer

            // 2. If Valid, mark all the records for deletion.
            self.drWB_CustomColumn.markDeleted();

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);
                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err);
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }


    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }

        const CustomColumn_options: CreateOptions = {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {}
        };

        const aRecResolver = new ESRecordResolver(dbContext, CustomColumn_options);

        return aRecResolver;
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Custom_Column,ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //<editor-fold desc="IHaveSecurity operations">

    private _PolicyCollection: IPolicyCollection
    private _bIHaveSecurityLoaded: boolean
    private _OnIHaveSecurityLoaded: Promise<IHaveSecurity>

    IHaveSecurity_init() {
        this._PolicyCollection = new PolicyCollection()
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
    }


    IHaveSecurity_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.OnIHaveSecurityLoaded
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    IHaveSecurity_AfterSaveComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            let policy: CustomColumnPolicy = self._PolicyCollection["CustomColumn"]
            policy.refreshPolicy().then(() => {
                resolve()
            })
                .catch((err) => {
                    error(err)
                })
        })
    }


    get OnIHaveSecurityLoaded(): Promise<IHaveSecurity> {
        const self = this

        if (this.bIHaveSecurityLoaded) {
            return ASync.resolve(this)
        }

        if (this._OnIHaveSecurityLoaded) {
            return this._OnIHaveSecurityLoaded
        }

        let aBOis = new PolicyBOis(['Super_User', 'Application_User'], ['Application_User'], self.WB_CustomColumn.cif.WB_CUSTOM_COLUMN_ID)
        self.PolicyCollection.addPolicy("BOis", aBOis)

        let aHasRolePolicy: PolicyHasRole
        let aCustomColumnPolicy: CustomColumnPolicy;

        this._OnIHaveSecurityLoaded = new Promise<IHaveSecurity>((resolve, error) => {
            aHasRolePolicy = new PolicyHasRole(self.WB_CustomColumn.cif.WB_CUSTOM_COLUMN_ID)
            aHasRolePolicy.OnLoadComplete
                .then((ignore) => {
                    self.PolicyCollection.addPolicy("HasRole", aHasRolePolicy)
                    aCustomColumnPolicy = new CustomColumnPolicy(self)
                    return aCustomColumnPolicy.OnLoadComplete
                })
                .then((ignore) => {
                    self.PolicyCollection.addPolicy("CustomColumn", aCustomColumnPolicy)
                    this._bIHaveSecurityLoaded = true
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })

        return this._OnIHaveSecurityLoaded
    }

    get PolicyCollection(): IPolicyCollection {
        return this._PolicyCollection
    }

    get bIHaveSecurityLoaded(): boolean {
        return this._bIHaveSecurityLoaded
    }


    //</editor-fold>
}
PAEnvironment.registerBusinessObjectClass( CustomColumnBO , "CustomColumnBO", "Custom Column")